import { motion } from "framer-motion";

const BRAND_BOARD =
  "https://customer-assets.emergentagent.com/job_creative-market-76/artifacts/u4so9s1o_email1783908274086image2.jpeg";

const PILLARS = [
  {
    n: "01",
    title: "Intentional",
    body: "Every strategy is built for your business and your audience — never templated, never rushed.",
  },
  {
    n: "02",
    title: "Professional",
    body: "Editorial-grade design, thoughtful copy, and clean execution across everything we touch.",
  },
  {
    n: "03",
    title: "Designed to Grow",
    body: "The work looks beautiful — but it's also engineered to move the needle for your business.",
  },
];

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="py-24 md:py-40 bg-[#F2EEE9] border-y border-[#E5E0D8]"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="col-span-12 md:col-span-5 wj-image-hover relative aspect-[4/5] overflow-hidden"
        >
          <img
            src={BRAND_BOARD}
            alt="Whitney Jean & Co. brand board — welcome"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-[#FBF9F6]">
            <span className="font-mono-label bg-[#1C1B1A] px-3 py-1.5">
              The Studio
            </span>
            <span className="font-serif-display text-lg italic">
              Whitney Jean &amp; Co.
            </span>
          </div>
        </motion.div>

        <div className="col-span-12 md:col-span-7 md:pl-8 lg:pl-16 flex flex-col justify-center">
          <div className="flex items-center gap-3">
            <span className="w-8 h-px bg-[#1C1B1A]"></span>
            <span className="font-mono-label text-[#635F59]">
              Our Philosophy
            </span>
          </div>

          <motion.blockquote
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="mt-8 font-serif-display text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight"
          >
            <span className="text-[#B4A087] text-6xl leading-none mr-2 align-top">
              &ldquo;
            </span>
            Thoughtful strategy.
            <span className="italic"> Beautiful design.</span> Real results.
          </motion.blockquote>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8">
            <p className="text-base md:text-lg text-[#635F59] leading-relaxed">
              Whitney Jean &amp; Co. was built to give small businesses and
              local brands the calibre of marketing usually reserved for the
              big names — without the big-agency ego, red tape, or price tag.
            </p>
            <p className="text-base md:text-lg text-[#635F59] leading-relaxed">
              We keep the roster small on purpose so every brand receives the
              same considered eye — from strategy through execution. Quality
              work. Fair prices. Real results.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {PILLARS.map((p) => (
              <div
                key={p.n}
                data-testid={`philosophy-pillar-${p.n}`}
                className="border-t border-[#1C1B1A]/20 pt-5"
              >
                <span className="w-8 h-px bg-[#B4A087] block"></span>
                <h3 className="mt-4 font-serif-display text-xl md:text-2xl">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-[#635F59] leading-relaxed">
                  {p.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
